module.exports = __webpack_public_path__ + "static/media/YouTube.6b90d587.svg";